import React  , { useEffect, useState } from 'react';
import axios from 'axios';
import GConf from '../../AssetsM/generalConf';
import date from 'date-and-time';
import fr from 'date-and-time/locale/fr';
import { Bounce, Slide } from 'react-reveal';
import { Area, AreaChart, Bar, BarChart, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { NavLink } from 'react-router-dom';
import CountUp from 'react-countup';
import { toast } from 'react-toastify';
import { Tab } from 'semantic-ui-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
 import ForumFullPage from '../../Dashboard/Used/Forum/forulFullPgae';

function MainPage() {
    /*#########################[Const]##################################*/
    const localsystemTag = localStorage.getItem(`${GConf.PID}_Secure_key`);
    const [statistique, setStat] = useState([]); 
    const [PieData, setPieData]= useState([])
    const [EleveData, setEleveData]= useState([])
    const [genreD, setGenreD]= useState([])
    const [commandeD, setCommandeD]= useState([])
    const [dataBar, setDataBar]= useState([])
    const [depoTR, setDepoRT]= useState([])
    const now = new Date();
    const [positions, setPositions] = useState([]);
    const [examListeDate , setFounisseurEvent] = useState([])
    date.locale(fr)
    const panes = [
            // {
            //     menuItem: 'Classes',
            //     render: () => <ChartsContainer chart={<PieChartCard data={genreD}/>} col='4' title='Distrubition des Plats' />,
            // },
            {
                menuItem: 'Forfait',
                render: () => <ChartsContainer chart={<PieChartCard data={commandeD}/>} col='4' title='Distrubition des Reervation' />,
                },
            {
                menuItem: 'Condidat',
                render: () => <ChartsContainer chart={<PieChartCard data={EleveData}/>} col='4' title='Distrubition des client' />,
            },
            {
                menuItem: 'Equipe',
                render: () => <ChartsContainer chart={<PieChartCard data={dataBar}/>} col='4' title='Distrubition des client' />,
            },
    ]

   /*#########################[UseEffect]##################################*/
    useEffect(() => {
        axios.post(`${GConf.ApiLink}/ma/stat`, {
            PID : GConf.PID,
          })
          .then(function (response) {

            if(response.data.activationState  && new Date(response.data.activationState.ExpiredThe) < new Date()){
                //LogOut()
                toast.error(<><div className='card-body w-100'>
                            <h3 className='text-danger'>Votre System est Expiré</h3> 
                                vous devez réactiver votre système , Voir <a href='/S/Parametre/paymment'> Paimment </a> pour plus d'info 
                                {/* ou bien contactez l'administration ABYEDH */}
                            </div>
                            </>, GConf.TostExpired)
            }

            console.log(response.data)
            setStat(response.data)

            
            let clientDis = []
            response.data.eleveDistro.map((datacld) => clientDis.push({ name: datacld.Gouv, value: datacld.Totale }))
            setEleveData(clientDis)

            let genreDist = []
            response.data.classesDistro.map((datacld) => genreDist.push({ name: datacld.Genre, value: datacld.Totale }))
            setGenreD(genreDist)

            let commandeDist = []
            response.data.abonnemmentDistro.map((datacld) => commandeDist.push({ name: datacld.AB_Permis, value: datacld.tot }))
            setCommandeD(commandeDist)
            
            let camionRT = []
            response.data.teamDistro.map((data) => camionRT.push({ name:  data.SE_Genre, value: data.Totale }))
            setDataBar(camionRT)

            let DepoRT = []
            response.data.evolutionSeance.map((data) => DepoRT.push({ name: data.SE_Date.split('T')[0],  value: data.Totale }))
            setDepoRT(DepoRT)
            
            let commandeContainer = []
            response.data.examProche.map( (commandeDate) => commandeContainer.push( { title: commandeDate.EX_Genre, className:'bg-transpareant border text-dark',  date:  commandeDate.EX_Date, url: `/S/cd/info/${commandeDate.Condidat_ID}`}))
            setFounisseurEvent(commandeContainer)

        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Les Donnée importeé sont les ancien donneé</div></>, GConf.TostInternetGonf) 
            }
          });
         
          const prompt = ` Voici des données statistiques : ${JSON.stringify(statistique)} Analyse ces données et génère un court paragraphe en français, clair et professionnel, destiné à un tableau de bord. `;
          
        //   axios.post( "https://api-inference.huggingface.co/models/mistralai/Mistral-7B-Instruct-v0.2",
        //         {
        //             inputs: prompt,
        //             parameters: {
        //             max_new_tokens: 120,
        //             temperature: 0.4
        //             }
        //         },
        //         {
        //             headers: {
        //             Authorization: `Bearer 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`,
        //             //"Content-Type": "application/json"
        //             }
        //         }
        //         )
        //         .then((response) => {
        //             console.log(response.data[0].generated_text);
        //         })
                
    }, [])

    /*###########################[Function]############################ */
    const  capitalizeFirstLetter = (string) =>{
        return string.replace(/ .*/,'');
    }
    

    /*#########################[Card]##################################*/
    const StatCard =  (props) => {

        return (<>
                
                <div className={`col-12 col-md -${props.data.col} mb-3`}>
                    <div className="card card-body bg-hover-card shadow-sm pb-2 border-div">
                        {/* <NavLink exact="true" to={`../${props.data.link}`}   className="stretched-link" /> */}
                        <div className="row">
                            <div className="col-4 align-self-center p-2">
                            <span className={`bi bi-${props.data.icon} bi-lg`} style={{color:GConf.themeColor}}></span>
                            </div>
                            <div className='col-8 align-self-center text-end p-2'>
                                <div className="text-center">
                                <h3 ><CountUp end={statistique[props.data.dataTag]} duration={3} /></h3>
                                    <small>{props.data.smallT}</small>
                                </div>
                            </div>
                        <div className='col-12 border-top pt-1 d-none'>
                            <div className="row p-2" style={{color:GConf.themeColor}}>
                                <div className="col-10 align-self-center">{props.data.desc}</div>
                                <div className="col-2 align-self-center"><span className="bi bi-arrow-right-short bi-sm"></span></div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                
        </>);
    }
    const LinkCard = (props) => {
        return(<>
        <div className="card p-2 bg-hover-card shadow-sm   border-div mb-2">
            <NavLink exact="true" to={`../${props.data.link}`}   className="stretched-link" /> 
            <div className="row">
                <div className="col-2 align-self-center text-center p-2">  <span className={`bi bi-${props.data.icon} bi-sm`} style={{color: props.data.colorTag}}></span> </div> 
                <div className="col-8 align-self-center p-2">{props.data.desc}</div> 
                <div className="col-2 align-self-center p-2"> <span className='bi bi-chevron-double-right'></span> </div> 
            </div> 
        </div>
        </>)
    }
    const PieChartCard =  (props) =>{
        
        const COLORS = ['#ce2085','#0088FE', '#00C49F', '#FFBB28'];
        return (
            <PieChart width={300} height={200} >
              <Pie
                data={props.data}
                cx={105}
                cy={100}
                innerRadius={60}
                outerRadius={80}
                fill="#8884d8"
                paddingAngle={2}
                dataKey="value"
              >
                {props.data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          );
    }
    const LineChts = (props) => {
        return (<>
           <ResponsiveContainer width="100%" height={220} >
                <AreaChart
                    width={200}
                    height={60}
                    data={depoTR}
                    margin={{ top: 20, right: 0, left: 0, bottom: 0, }}
                >
                <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor={GConf.themeColor} stopOpacity={0.8}/>
                        <stop offset="95%" stopColor={GConf.themeColor} stopOpacity={0}/>
                    </linearGradient>
                </defs>
                    <Tooltip />
                        <Area type="monotone" dataKey="value" stroke={GConf.themeColor} strokeWidth={3} fill="url(#colorUv)" />
                        <XAxis hide  dataKey="name" />
                        <YAxis hide domain={[0, (Math.max(...depoTR.map(o => o.value)) + 1)]} />
          </AreaChart>
            </ResponsiveContainer>
        </>)
    }
    const BarCht = (props) => {

        return (<>
        <ResponsiveContainer  height={200} >
            <BarChart
                layout="vertical"
                data={dataBar} 
            >
                <Tooltip cursor={{fill: 'transparent'}} />
                <Bar dataKey="value" fill={GConf.themeColor}  barSize={15}  radius={[0, 10, 10, 0]}/>
                <XAxis type="number" domain={[0, (Math.max(...dataBar.map(o => o.value)) + 10)]} hide  dataKey="value"/>
                <YAxis type="category"   dataKey='name' />
                
            </BarChart>
        </ResponsiveContainer>
        </>)
    }
    const TopCardTime = () =>{
        return(<>
            <div className='card card-body mb-4 rounded-system  main-big-card-img shaodw-sm'>
                <div className='row'>
                    <div className='col-8'>
                        <h1 className='text-white mb-0'>{date.format(now, 'dddd')}</h1>
                        <h1 className='text-white mt-0'>{date.format(now, ' DD - MMMM - YYYY')}</h1>
                    </div>
                    <div className='col-4 text-end align-self-center'>
                        <h1 style={{color:GConf.themeColor}}>{date.format(now, 'HH:mm')}</h1>
                    </div>
                </div>
            </div>
        </>)
    }
    const LinksCrads = () => {
        return(<>
            <div className="row justify-content-center mb-2">
                {GConf.LinkCard.map((stat,index) =>
                    <StatCard key={index} data={stat}   />
                )}
            </div>
        </>)
    }
    const NotificationCard = () =>{
        return(<>
        <div className="card border-div shadow-sm p-2 mb-3">
            
        </div>
        </>)
    }
    const ChartsContainer = (props) =>{
        return(<>
                {/* <div className={`col-12 col-lg-${props.col} mb-4`}> */}
                
                    <div className="card p-1  border-div">
                        <h6 className='ms-2 mt-2 mb-0'><b>{props.title}</b></h6>
                        {props.chart}
                    </div>
                    
                {/* </div> */}
                </>)
    }

    /*#########################[Functions]##################################*/
    const LogOut = () =>{
        localStorage.clear();
        window.location.href = "/login";
    }
    
    return (<>
        <br />
        <TopCardTime />
        <Slide  bottom > 
             <div className='row p-0 justify-content-center'>
                <div className='col-12 col-lg-8 mb-4'>
                    <LinksCrads /> 
                    {/* <NotificationCard />  */}
                    <ChartsContainer chart={<LineChts />} col='7' title='Seance par date' />
                    <div className='row p-0 mt-3'>
                        <div className='col-12 col-lg-4 mb-4'> <ChartsContainer chart={<PieChartCard data={commandeD}/>} col='4' title='Distrubition des Permis' /></div>
                        <div className='col-12 col-lg-4 mb-4'> <ChartsContainer chart={<PieChartCard data={EleveData}/>} col='4' title='Distrubition des Condidat' /></div>
                        <div className='col-12 col-lg-4 mb-4'> <ChartsContainer chart={<PieChartCard data={dataBar}/>} col='4' title='Distrubition Seances' /></div>
                    </div>
                    <div className='card border-div mb-3 mt-1'>
                       <h5 className='m-3 mb-2'>Suivie la positions des voitures </h5> 
                        <MapContainer center={positions.length == 0 ? [36.17720,9.12337] : [positions[0].latitude, positions[0].longitude]} zoom={15} scrollWheelZoom={false} className="map-height" >
                            <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {positions.map( (cord,i) => <Marker key={i} position={[cord.latitude, cord.longitude]}> <Popup>{cord.targetTime}</Popup></Marker> )}
                        </MapContainer>
                    </div>
                    <div className='card p-3 border-div mb-3 mt-1'>
                       <h5 className='  mb-2'>Calendrier des examen </h5> 
                        <FullCalendar 
                            plugins={[ dayGridPlugin  ]}
                            //initialView="dayGridWeek"
                            locale='fr' 
                            events={examListeDate}
                            height='400px'
                            allDaySlot= {false}
                            navLinks={true}
                            buttonText= {{ today:'aujourd\'hui', }}
                        />
                    </div>
                    {/* <ForumFullPage /> */}
                </div>
                <div className='col-12 col-lg-3 mb-4'>
                    <div className="sticky-top" style={{top:'70px', zIndex:2}}>
                        {GConf.LinkCardFull.map((stat,index) =>
                            <LinkCard key={index} data={stat}   />
                        )}

                    </div>   
                </div>
             </div>
        </Slide > 
 
    </>);
}

export default MainPage;